import React, { useState } from 'react';
import {
  Box,
  Drawer,
  IconButton,
  Typography,
  useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/MenuRounded';
import { useTheme } from '@mui/material/styles';
import Site2NavBar, { SIDEBAR_WIDTH } from './Site2NavBar';
import UpdateNotification from './UpdateNotification';
import { palette } from '../theme-site2';

// Site2Layout — the default app shell since Phase 1 of the migration
// (Apr 28, 2026). Permanent dark sidebar on md+ screens, slide-out
// drawer on small screens, light page content on the right.
//
// The old top-NavBar Layout still lives at /legacy/* as a safety net
// until Phase 5 retires it.
const Site2Layout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => setMobileOpen((prev) => !prev);

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: palette.pageBg,
      }}
    >
      {/* Sidebar — permanent on desktop, drawer on mobile */}
      {!isMobile && <Site2NavBar />}

      {isMobile && (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          PaperProps={{
            sx: {
              width: SIDEBAR_WIDTH,
              backgroundColor: palette.sidebarBg,
              borderRight: 'none',
              padding: 0,
            },
          }}
        >
          <Site2NavBar variant="temporary" onNavigate={handleDrawerToggle} />
        </Drawer>
      )}

      {/* Main column */}
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
        }}
      >
        {/* Mobile hamburger row — desktop has the sidebar always visible */}
        {isMobile && (
          <Box
            sx={{
              px: 2,
              py: 1,
              borderBottom: `1px solid ${palette.cardBorder}`,
              backgroundColor: '#ffffff',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <IconButton
              onClick={handleDrawerToggle}
              size="small"
              aria-label="open navigation"
            >
              <MenuIcon />
            </IconButton>
            <Typography
              sx={{
                ml: 1,
                fontSize: '1rem',
                fontWeight: 700,
                color: palette.textPrimary,
              }}
            >
              LOBI
            </Typography>
          </Box>
        )}

        {/* Page content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: { xs: 2, md: 3 },
            backgroundColor: palette.pageBg,
            minWidth: 0,
          }}
        >
          {children}
        </Box>
      </Box>

      <UpdateNotification />
    </Box>
  );
};

export default Site2Layout;
